<template>
  <div>
    <el-form style="height: 99%; position: absolute; width: 100%" :inline="true" :model="companyInfo"
      :rules="rules" ref="refForm" label-width="110px" label-position="right"
      label-suffix=" ：">
      <el-scrollbar style="height: 100%">
        <div style="display: flex;margin-bottom: 15px;">
          <div style="width: 73%">
            <el-col :span="24">
              <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="companyInfo.companyName" clearable placeholder="请输入公司名称" :disabled="pageStates == 'edit' ? true: false"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="联系电话" prop="companyPhone">
                <el-input clearable autocomplete="off" v-model="companyInfo.companyPhone" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="公司地址" prop="companyAddress">
                <el-input maxlength="200" show-word-limit clearable type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5 }" v-model="companyInfo.companyAddress" placeholder="请输入公司地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="公司类型" prop="companyType">
                  <el-radio-group v-model="companyInfo.companyType">
                    <el-radio :label="'1'">优合公司</el-radio>
                    <el-radio :label="'2'">第三方公司</el-radio>
                  </el-radio-group>
              </el-form-item>
            </el-col>
          </div>
          <div style="width: 25%;display: flex;flex-direction: column;justify-content: center;align-items: center;margin-left: 2%;">
            <el-form-item label="" prop="companyImage">
              <el-col :span="24">
                <el-upload action v-if="!fileList.length" :file-list="fileList"
                  :show-file-list="false" :list-type="'picture-card'" accept="image/png, image/jpg, image/jpeg, image/bpm, image/bmp, image/tif, image/gif"
                  :auto-upload="false" :multiple="false" :limit="1" :on-change="onChangeFile" :on-remove="onRemoveFile">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="imgFile" v-else>
                  <img :src="imageUrl" @click="showViewer" :class="'uploadImg'"
                    @error="showError" />
                  <div class="delete-icon">
                    <i class="el-icon-delete" @click="onRemoveFile"></i>
                  </div>
                </div>
              </el-col>
            </el-form-item>
            <div>
              图片尺寸需要大于100*100像素, 支持bmp.jpg, png, tif, gif格式, 大小不能超过5MB。
            </div>
          </div>
        </div>
        
        <div>
          <el-col :span="24">
              <el-form-item label="公司邮箱" prop="companyMail">
                <el-input clearable v-model="companyInfo.companyMail" placeholder="默认地址:example@example.com"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="公司简介" prop="companyProfile">
                <el-input maxlength="200" show-word-limit clearable type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5 }" v-model="companyInfo.companyProfile" placeholder="请输入公司简介"></el-input>
              </el-form-item>
            </el-col>
        </div>
        
      </el-scrollbar>
    </el-form>
  </div>
</template>

<script>
import { api } from "../api";
import sha256 from "@src/common/lib/sha";
import utils from "@src/common/utils";

const resetForm = () => {
  return {
    companyCode: undefined, // 公司编码
    companyName: "", // 公司名称
    companyPhone: "", // 联系电话
    companyAddress: "", // 公司地址
    companyType: "", // 公司类型（1：优合公司 2：第三方公司）,
    companyMail: "example@example.com", // 公司邮箱
    companyProfile: "", // 公司简介
    companyImage: "", // 公司logo
  };
};
export default {
  props: {
    pageStates: {
      type: String,
      default: "add",
    },
  },
  data() {
    const validateEmails = (rule, value, callback) => {
      // var reg = new RegExp('^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$')
      var reg = new RegExp(
        "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$"
      );
      if (!reg.test(value)) {
        callback(new Error("邮箱格式不正确"));
      } else if (value.indexOf("@") > 18 || value.indexOf("@") < 4) {
        callback(new Error("邮箱前缀为 4 到 18 个字符"));
      } else {
        callback();
      }
    };

    const validatePhone = (rule, value, callback) => {
      var reg = new RegExp("^1[3456789]\\d{9}$");
      if (!reg.test(value)) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };
    return {
      imageUrl: "",
      fileList: [],
      companyInfo: resetForm(),
      rules: {
        companyName: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: ["blur", "change"],
          },
          {
            min: 4,
            max: 30,
            message: "长度在 4 到 30 个字符",
            trigger: "blur",
          },
        ],
        companyPhone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: ["blur", "change"],
          },
          {
            validator: validatePhone,
            trigger: ["blur", "change"],
          },
        ],
        companyAddress: [
          {
            required: true,
            message: "请输入公司地址",
            trigger: ["blur", "change"],
          },
        ],
        companyType: [
          {
            required: true,
            message: "请选择公司类型",
            trigger: ["blur", "change"],
          },
        ],
        companyMail: [
          {
            required: false,
            message: "请输入公司邮箱",
            trigger: ["blur", "change"],
          },
          {
            min: 6,
            max: 64,
            message: "长度在 6 到 64 个字符",
            trigger: "blur",
          },
          {
            validator: validateEmails,
            trigger: "blur",
          },
        ],
        companyImage: [
          {
            required: true,
            message: "请上传图片",
            trigger: ["change"],
          },
        ],
      },
      
    };
  },
  mounted() {
    this.parkType = [utils.Cache.get("CACHE_USER_INFO").parkInfoTree];
  },
  methods: {
    showViewer(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    showError() {
      this.imageUrl = "/images/theme/newDark/default.png";
      this.companyInfo.companyImage = "";
      this.$message.error("公司图片获取失败，重新上传！");
    },
    handleSetForm(info) {
      this.companyInfo = {
        ...info,
      };
      this.fileList.push({
        url: this.getImgPath(this.companyInfo.companyImage),
        status: "update",
        fileCode: this.companyInfo.companyImage,
      });
      this.$refs.refForm.clearValidate();
      this.imageUrl = utils.Bus.imgPath(this.companyInfo.companyImage);
      // console.log(this.companyInfo);
    },
    handleRestForm() {
      this.fileList = [];
      this.imageUrl = "";
      this.companyInfo = resetForm();
      // this.$refs.refForm.resetFields();
      this.$nextTick(() => {
        this.$refs["refForm"].clearValidate();
      });
    },
    validImg(file) {
      // 文件大小
      const isLt5M = file.size / 1024 / 1024 <= 5;
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = ["jpg", "png", "jpeg", "bpm", "tif", "gif", "JPG", "PNG", "JPEG", "BPM", "TIF", "GIF"];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);
      if (!isJPG) {
        this.$message.error(this.$t("videoPatrol.message.sizePicture"));
        return false;
      }
      if (!isLt5M) {
        this.$message.error(this.$t("videoPatrol.message.largePicture"));
        return false;
      }
      return true;
    },
    onChangeFile(file, fileList) {
      if (!this.validImg(file)) {
        this.imageUrl = "";
        this.fileList = [];
        return false;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
      this.fileList = fileList;
      this.companyInfo.companyImage = "add";
      this.$refs.refForm.clearValidate("companyImage");
    },
    onRemoveFile(file, fileList) {
      this.$confirm("确认要删除图片吗？", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.imageUrl = "";
        this.fileList = [];
        this.companyInfo.companyInfo = "";
      });
    },
    getImgPath(item) {
      return item ? utils.Bus.imgPath(item) : "";
    },
    submit() {
      this.$refs.refForm.validate((res) => {
        if (res) {
          let params = { ...this.companyInfo };
          if (
            (!this.companyInfo.companyImage || this.companyInfo.companyImage == "add") &&
            this.fileList.length
          ) {
            let formData = new FormData();
            this.fileList.map((item) => {
              formData.append("files", item.raw);
            });
            this.$fetch(api.company.batchFileload, formData).then((res) => {
              if (res.returnObj.length > 0) {
                params.companyImage = res.returnObj[0].fileId;
              }
              this.$emit("save-company-info", params);
            });
          } else {
            this.$emit("save-company-info", params);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep .el-upload--picture-card {
  width: 85%;
  margin: 5px 0px 0;
  height: 175px;
  line-height: 175px;
}

.el-form-item {
  width: 100%;
  display: flex;

  :deep .el-form-item__content {
    width: calc(100% - 125px);
  }

  :deep .el-upload--picture-card {
    width: 180px;
    height: 175px;
    // background: #0d121c;
  }

  .el-input__inner {
    width: 100%;
  }
}

.imgFile {
  // display: flex;
  // width: 148px;
  height: 185px;
  position: relative;

  .viewImg {
    width: 180px;
    height: 175px;
    cursor: pointer;
  }

  .uploadImg {
    margin: 5px 0;
    width: 180px;
    height: 175px;
    cursor: pointer;
  }

  &:hover {
    .delete-icon {
      opacity: 1;
    }
  }

  .delete-icon {
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 3px;
    left: 0;
    width: 180px;
    height: 177px;
    border-radius: 6px;
    opacity: 0;
    cursor: pointer;
    background-color: rgba($color: #000000, $alpha: 0.4);
    transition: all 0.2s;
    box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
  }
}
</style>
